import Vue from 'vue'

const fields = [
    'label',
    'connect_time',
    'wakeup',
    'power_factor',
    'power_off_delay',
    'max_runtime',
    'max_runtime_delay',
    'voltage',
    'alarm_delay',
    'alarm_delay_2',
    'calibration',
    'calibration_2',
    'temperature_limits',
    'temperature_limits_2',
    'reminder',
    'resync',
    'digital_input_delay',
    'pulse_input',
    'power_max_idle',
    'power_limits_delay',
    'power_limits',
    'hibernate_max_power',
    'service_interval',
    'servicekit_interval',
    'service_notification_enabled',
    'service_notification_email',
    'servicekit_notification_email',
];

export const updateSensorSettings = ({state, commit}, settings) => {
    let data = {};

    for (var key in settings) {
        if (settings.hasOwnProperty(key)) {
           if(fields.indexOf(key) > -1)
               data[key] = settings[key];
        }
    }

    return Vue.prototype.$rest.put("/sensor/" + settings.id + "/settings", data).then(() => {
        settings.serial = settings.id;
        commit("sensorUpdated", settings);
    });
}


export const deactivateSensor = ({state, commit}, sensor) => {
    return Vue.prototype.$rest.delete("/sensor/" + sensor.serial + "/activation").then(() => {
        commit("sensorRemoved", sensor);
    });
}


export const removeSensor = ({state, commit}, sensor) => {
    return Vue.prototype.$rest.delete("/sensor/" + sensor.serial).then(() => {
        commit("sensorRemoved", sensor);
    });
}



// WEBPACK FOOTER //
// ./src/store/actions/sensors.js